import React, { useEffect, useState } from 'react'
import '../../assets/css/ConsultationForm.css'
import 'bootstrap/dist/css/bootstrap.css'
import { pageTitle, DetailsOfConsultation, Remarks, RemarksPlaceholder, RemarksText, consultBirthdate, consultContractStatus, consultContractStatusContracted, consultContractStatusNoContract, consultDay, consultEmailAddress, consultEmailAddressPlaceholder, consultGender, consultGenderFemale, consultGenderMale, consultKanaFirstName, consultKanaFirstNamePlaceHolder, consultKanaLastName, consultKanaLastNamePlaceHolder, consultKanaName, consultKanjiFirstName, consultKanjiFirstNamePlaceHolder, consultKanjiLastName, consultKanjiLastNamePlaceHolder, consultKanjiName, consultMonth, consultTelephoneNumber, consultTelephoneNumberPlaceholder1, consultYear, consultZipcode, consultZipcodePlaceholder1, faceToface, faceTofacelabelText, onlineText } from '../../utils/ConsultationAppText'
import Tooltip from '../../utils/Tooltips'
import { CDP_API_URL, CDP_PUBLIC_URL } from '../../utils/Constants'
import { errorMessages } from '../form/FormValidationRules'
import InputScreenErrorMessage from '../InputScreenErrorMessage'
import { headers } from '../../api/CDPAPI'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'
import { bannerCodeOnline } from '../../utils/bannerCodeOnline'
import { bannerCodeF2F } from '../../utils/bannerCodeF2F'
import * as wanakana from 'wanakana'

const ConsultationServiceForm = () => {
  const location = useLocation()
  const findLocation = window.location.href
  const [consultationConfirmData, setConsultationConfirmData] = useState(location.state ? location.state.formData : {})
  const [isBack, setIsBack] = useState(location.state ? location.state.isBack : false)
  const [xmlResponseData, setXmlResponseData] = useState([])
  const navigate = useNavigate()
  const [data, setData] = useState({})
  const [button, setButton] = useState(false)
  const [kanjiLastName, setKanjiLastName] = useState('')
  const [kanjiLastNameOuterBorderRed, setKanjiLastNameOuterBorderRed] = useState(false)
  const [kanjiFirstName, setKanjiFirstName] = useState('')
  const [kanjiFirstNameOuterBorderRed, setKanjiFirstNameOuterBorderRed] = useState(false)
  const [kanaFirstName, setKanaFirstName] = useState('')
  const [kanaFirstNameOuterBorderRed, setKanaFirstNameOuterBorderRed] = useState(false)
  const [kanaLastName, setKanaLastName] = useState('')
  const [kanaLastNameOuterBorderRed, setKanaLastNameOuterBorderRed] = useState(false)
  const [year, setYear] = useState('')
  const [yearOuterBorderRed, setYearOuterBorderRed] = useState(false)
  const [month, setMonth] = useState('')
  const [monthOuterBorderRed, setMonthOuterBorderRed] = useState(false)
  const [day, setDay] = useState('')
  const [dayOuterBorderRed, setDayOuterBorderRed] = useState(false)
  const [gender, setGender] = useState('')
  const [online, setOnline] = useState('')
  const [contracted, setContracted] = useState('')
  const [detailsOfConsultation, setDetailsOfConsultation] = useState([])
  const [zipcode1, setZipcode1] = useState('')
  const [zipcode1OuterBorderRed, setZipcode1OuterBorderRed] = useState(false)
  const [telephone1, setTelephone1] = useState('')
  const [telephone1uterBorderRed, setTelephone1OuterBorderRed] = useState(false)
  const [email, setEmail] = useState('')
  const [emailOuterBorderRed, setEmailOuterBorderRed] = useState(false)
  const [error, setError] = useState({})
  const [descriptionText, SetDescriptionText] = useState('')
  const [count, setCount] = useState('14')
  const [InputChange, setInputChange] = useState(false)
  const [InputChange1, setInputChange1] = useState(false)
  const [InputChangeKana, setInputChangeKana] = useState(false)
  const [InputChangeKana1, setInputChangeKana1] = useState(false)
  const [InputZip1, setInputZip1] = useState(false)
  const [InputTel1, setInputTel1] = useState(false)
  const [InputEmail, setInputEmail] = useState(false)
  const [isLabelChangeKanji, setIsLabelChangeKanji] = useState(false)
  const [isLabelChangeKana, setIsLabelChangeKana] = useState(false)
  const [isLabelChangeZipCode, setIsLabelChangeZipCode] = useState(false)
  const [isLabelChangePHno, setIsLabelChangePHno] = useState(false)
  const [isLabelChangeEmail, setIsLabelChangeEmail] = useState(false)
  const [isLabelChangeRemarks, setIsLabelChangeRemarks] = useState(false)
  const [onlineCampaignCode, setOnlineCampaignCode] = useState({})
  const [f2fCampaignCode, setF2FCampaignCode] = useState({})
  const InputZip1Check = () => {
    setInputZip1(true)
  }
  const InputTel1Check = () => {
    setInputTel1(true)
  }
  const InputEmailCheck = () => {
    setInputEmail(true)
  }
  const onClickFirstInput = () => {
    setInputChange(true)
  }
  const onClickFirstInput1 = () => {
    setInputChange1(true)
  }
  const onClickKanaInput = () => {
    setInputChangeKana(true)
  }
  const onClickKana1Input = () => {
    setInputChangeKana1(true)
  }
  const countCheckvalue = () => {
    const inputs = document.getElementsByClassName('required-input')
    let empty = 0
    for (let i = 0, len = inputs.length; i < len; i++) {
      if (inputs[i].type === 'radio' || inputs[i].type === 'checkbox') {
        const name = inputs[i].name
        const checked = document.querySelector('input[name=' + name + ']:checked')
        if (!checked || !checked.value) {
          empty++
        }
      } else {
        empty += !inputs[i].value
      }
    }
    setCount(empty)
  }
  const onBlurCount = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
  }
  const onBlurkanjiLastNameHandler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setInputChange(false)
    setKanjiLastNameOuterBorderRed(true)
  }
  const onBlurkanjiFirstNameHandler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setInputChange1(false)
    setKanjiFirstNameOuterBorderRed(true)
  }
  const onBlurKanaFirstNameHandler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setKanaFirstNameOuterBorderRed(true)
    setInputChangeKana(false)
  }
  const onBlurKanaLastNameHandler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setKanaLastNameOuterBorderRed(true)
    setInputChangeKana1(false)
  }
  const onBlurYearHandler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setYearOuterBorderRed(true)
  }
  const onBlurMonthHandler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setMonthOuterBorderRed(true)
  }
  const onBlurDayHandler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setDayOuterBorderRed(true)
  }
  const onBlurZipcode1Handler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setZipcode1OuterBorderRed(true)
    setInputZip1(false)
  }
  const onBlurTelephone1Handler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setTelephone1OuterBorderRed(true)
    setInputTel1(false)
  }
  const onBlurEmailHandler = (e) => {
    if (e.target.value !== undefined || e.target.value !== null || e.target.value !== '') {
      countCheckvalue()
    }
    setEmailOuterBorderRed(true)
    setInputEmail(false)
  }
  // ----- bannerCode------ //
  const getQueryVariable = (variable) => {
    const queryString = findLocation.split('?')[1]
    if (!queryString) {
      return false
    }
    const params = new URLSearchParams(queryString?.toLowerCase()) // case insensitive param
    return params.get(variable)?.toUpperCase() // return uppercase BannerCode
  }

  function getCookieVariable (key) {
    const cookies = document.cookie.split(';')
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=')
      if (name?.toLowerCase() === key) {
        return value
      }
    }
    return false
  }

  function getCampaignCode (BannerCode) {
    if (online === 'オンライン形式') {
      return onlineCampaignCode[BannerCode]
    } else {
      return f2fCampaignCode[BannerCode]
    }
  }

  function getDefaultCampaignCode () {
    if (online === 'オンライン形式') {
      return 'W036'
    } else {
      return 'W033'
    }
  }

  const bannerCode = (findLocation.toString()?.toLowerCase().includes('bannercode') && getQueryVariable('bannercode')?.length > 0)
                      ? getQueryVariable('bannercode')
                      : getCookieVariable('bannercode')
                        ? getCookieVariable('bannercode')
                        : ''
  const campaignCode = getCampaignCode(bannerCode)
                        ? getCampaignCode(bannerCode)
                        : getDefaultCampaignCode()

  const para = getQueryVariable('para')

  // ----- bannerCode end------ //

  const onChangeInputEnterHandler = (e) => {
    SetDescriptionText(e.target.value)
  }
  const onChangekanjiLastNameHandler = (e) => {
    setKanjiLastName(e.target.value)
    if (!wanakana.isKanji(e.target.value)) {
      setKanaLastName(wanakana.toKatakana(e.target.value), { passRomaji: true })
    }
  }
  const onChangekanjiFirstNameHandler = (e) => {
    setKanjiFirstName(e.target.value)
    if (!wanakana.isKanji(e.target.value)) {
      setKanaFirstName(wanakana.toKatakana(e.target.value), { passRomaji: true })
    }
  }
  const onChangeKanaFirstNameHandler = (e) => {
    setKanaFirstName(e.target.value)
  }
  const onChangeKanaLastNameHandler = (e) => {
    setKanaLastName(e.target.value)
  }
  const onChangeYearHandler = (e) => {
    setYear(e.target.value)
  }
  const onChangeMonthHandler = (e) => {
    setMonth(e.target.value)
  }
  const onChangeDayHandler = (e) => {
    setDay(e.target.value)
  }
  const onChangeGenderHandler = (e) => {
    setGender(e.target.value)
  }
  const onChangeOnlineHandler = (e) => {
    setOnline(e.target.value)
  }
  const onChangeContractedHandler = (e) => {
    setContracted(e.target.value)
  }
  const onChangeDetailsOfConsultation = (e, item) => {
    if (e.target.checked) {
      setDetailsOfConsultation([...detailsOfConsultation, item])
    } else {
      setDetailsOfConsultation(detailsOfConsultation.filter(val => val !== item))
    }
  }
  const onChangeZipcode1Handler = (e) => {
    setZipcode1(e.target.value)
  }
  const onChangeTelephone1Handler = (e) => {
    setTelephone1(e.target.value)
  }
  const onChangeEmailHandler = (e) => {
    setEmail(e.target.value)
  }
  const handleChangeData = (event) => {
    if (event.target.type === 'checkbox') {
      if (event.target.checked) {
        setData({ ...data, [event.target.id]: event.target.value })
      } else {
        const { [event.target.id]: removedProp, ...newValues } = data
        setData(newValues)
      }
    } else if (event.target.type !== 'checkbox') {
      setData({ ...data, [event.target.name]: event.target.value })
    }

    setError((prevErrors) => ({
      ...prevErrors,
      [name]: ''
    }))
  }
  // ---------errormssg --- //
  const headerErrorMssg =
    (kanjiLastName === null || kanjiLastName === '' || kanjiLastName === undefined ||
      kanjiFirstName === null || kanjiFirstName === '' || kanjiFirstName === undefined ||
      kanaFirstName === null || kanaFirstName === '' || kanaFirstName === undefined ||
      kanaLastName === null || kanaLastName === '' || kanaLastName === undefined ||
      year === null || year === '' || year === undefined ||
      month === null || month === '' || month === undefined ||
      day === null || day === '' || day === undefined ||
      gender === null || gender === '' || gender === undefined ||
      online === null || online === '' || online === undefined ||
      contracted === null || contracted === '' || contracted === undefined ||
      detailsOfConsultation === null || detailsOfConsultation === '' || detailsOfConsultation === undefined || detailsOfConsultation.length === 0 ||
       zipcode1 === null || zipcode1 === '' || zipcode1 === undefined ||
       telephone1.length === 0 ||
      email.length === 0)
  // --------API Integration ------- //
  const fetchData = async () => {
    const data = {
      consultLastNameKanji: kanjiLastName,
      consultFirstNameKanji: kanjiFirstName,
      consultLastNameKana: kanaLastName,
      consultFirstNameKana: kanaFirstName,
      consultBirthYear: year,
      consultBirthMonth: month,
      consultBirthDay: day,
      consultGender: gender,
      consultZipcode: zipcode1,
      consultTelephone: telephone1,
      consultEmail: email,
      faceToface: online,
      consultContractStatus: contracted,
      detailsOfConsultation: detailsOfConsultation,
      consultRemarks: descriptionText, // === 'オンライン形式' ? addValueForOnlineRadioButton : addValueForFaceToFaceRadioButton
      bannerCode: bannerCode,
      campaignCode: campaignCode
    }
    try {
      const response = await fetch(`${CDP_API_URL}/consult-validate-names`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
      })
      const data1 = await response.json()
      const newError = {}
      data1.systemMessages.forEach(item => {
        if (item.messageCode !== '') {
          newError.headErrorMssg = errorMessages.headErrorMssg
        }
        if (item.messageCode === 'datavalidated') {
          navigate(`${CDP_PUBLIC_URL}/consulting/confirm`, { state: data })
        } else if (item.messageCode === 'SVC_10_400_36') {
          setIsLabelChangeKanji(true)
          newError.overCharLimitKanji = errorMessages.overCharLimitKanji
        } else if (item.messageCode === 'SVC_10_400_22') {
          setIsLabelChangeKanji(true)
          newError.invalidFormatKanji = errorMessages.invalidFormatKanji
        } else if (item.messageCode === 'SVC_10_400_37') {
          setIsLabelChangeKanji(true)
          newError.overCharLimitKanji = errorMessages.overCharLimitKanji
        } else if (item.messageCode === 'SVC_10_400_24') {
          setIsLabelChangeKanji(true)
          newError.invalidFormatKanji = errorMessages.invalidFormatKanji
        } else if (item.messageCode === 'SVC_10_400_26') {
          setIsLabelChangeKana(true)
          newError.invalidFormatKana = errorMessages.invalidFormatKana
        } else if (item.messageCode === 'SVC_10_400_28') {
          setIsLabelChangeKana(true)
          newError.invalidFormatKana = errorMessages.invalidFormatKana
        } else if (item.messageCode === 'SVC_10_400_38') {
          setIsLabelChangeKana(true)
          newError.overCharLimitKana = errorMessages.overCharLimitKana
        } else if (item.messageCode === 'SVC_10_400_39') {
          setIsLabelChangeKana(true)
          newError.overCharLimitKana = errorMessages.overCharLimitKana
        } else if (item.messageCode === 'SVC_10_400_29') {
          setIsLabelChangeZipCode(true)
          newError.invalidIfEmpty = errorMessages.invalidIfEmpty
        } else if (item.messageCode === 'SVC_10_400_30_1') {
          setIsLabelChangeZipCode(true)
          newError.insufficientInput = errorMessages.insufficientInput
        } else if (item.messageCode === 'SVC_10_400_31') {
          setIsLabelChangeZipCode(true)
          newError.invalidCharZipCode = errorMessages.invalidCharZipCode
        } else if (item.messageCode === 'SVC_10_400_32') {
          setIsLabelChangePHno(true)
          newError.invalidIfEmpty = errorMessages.invalidIfEmpty
        } else if (item.messageCode === 'SVC_10_400_30_2') {
          setIsLabelChangePHno(true)
          newError.insufficientInputs = errorMessages.insufficientInputs
        } else if (item.messageCode === 'SVC_10_400_33') {
          setIsLabelChangePHno(true)
          newError.isOverLimit = errorMessages.invalidChar
        } else if (item.messageCode === 'SVC_10_400_35') {
          setIsLabelChangeEmail(true)
          newError.invalidFormatEmail = errorMessages.invalidFormatEmail
        } else if (item.messageCode === 'SVC_10_400_40') {
          setIsLabelChangeRemarks(true)
          newError.isF2FRemarksLimit = errorMessages.isF2FRemarksLimit
        }
        window.scrollTo(0, 0)
      })
      setError(newError)
    } catch (error) {
    }
  }
  const SubmitButtonClick = async (e) => {
    fetchData()
    setButton(true)
    setIsLabelChangeKanji(false)
    setIsLabelChangeKana(false)
    setIsLabelChangeZipCode(false)
    setIsLabelChangePHno(false)
    setIsLabelChangeEmail(false)
  }

  const fetchCampaignCode = async () => {
    try {
      const [onlineResponse, f2fResponse] = await Promise.all([
        fetch('js/bannerCodeOnline.json'),
        fetch('js/bannerCodeF2F.json')
      ])
      const [onlineData, f2fData] = await Promise.all([
        onlineResponse.json(),
        f2fResponse.json()
      ])
      setOnlineCampaignCode(onlineData)
      setF2FCampaignCode(f2fData)
    } catch (error) {
      console.log('JSON fetch fail')
      setOnlineCampaignCode(bannerCodeOnline)
      setF2FCampaignCode(bannerCodeF2F)
    }
  }

  const fetchCheckboxes = async () => {
    axios.post(`${CDP_API_URL}/get-chkbox`, {
      headers: headers
    }).then((response) => {
      setXmlResponseData(response.data.charBoxNames.map.names.myArrayList)
    },
    (error) => {
      console.log(error)
    })
  }
  const clearValues = () => {
      setKanjiLastName('')
      setKanjiFirstName('')
      setKanaLastName('')
      setKanaFirstName('')
      setYear('')
      setMonth('')
      setDay('')
      setGender('')
      setZipcode1('')
      setTelephone1('')
      setEmail('')
      setOnline('')
      setContracted('')
      setDetailsOfConsultation([])
      SetDescriptionText('')
      setCount('')
  }
  const populateValues = () => {
    if (para !== '') {
      if (para === '3') {
        setOnline('対面形式')
      } else if (para === '5') {
        setOnline('オンライン形式')
      }
    }
    if (isBack && consultationConfirmData) {
      setKanjiLastName(consultationConfirmData.consultLastNameKanji)
      setKanjiFirstName(consultationConfirmData.consultFirstNameKanji)
      setKanaLastName(consultationConfirmData.consultLastNameKana)
      setKanaFirstName(consultationConfirmData.consultFirstNameKana)
      setYear(consultationConfirmData.consultBirthYear)
      setMonth(consultationConfirmData.consultBirthMonth)
      setDay(consultationConfirmData.consultBirthDay)
      setGender(consultationConfirmData.consultGender)
      setZipcode1(consultationConfirmData.consultZipcode)
      setTelephone1(consultationConfirmData.consultTelephone)
      setEmail(consultationConfirmData.consultEmail)
      setOnline(consultationConfirmData.faceToface)
      setContracted(consultationConfirmData.consultContractStatus)
      setDetailsOfConsultation(consultationConfirmData.detailsOfConsultation)
      SetDescriptionText(consultationConfirmData.consultRemarks)
      setCount('1')
      setIsBack(false)
      setConsultationConfirmData({})
      location.state.isBack = false
      location.state.formData = {}
    }
  }
  useEffect(() => {
    document.title = pageTitle
    clearValues()
    fetchCheckboxes()
    fetchCampaignCode()
    populateValues()
  }, [])
  return (
    < div className="inputSection">
      <div className="cardContainer row">
        {(button === true) ? <div className="errDisplayArea1" style={{ fontSize: '16px', marginBottom: '30px' }}><InputScreenErrorMessage errorMessage={error.headErrorMssg}></InputScreenErrorMessage></div> : ''}
        <div className="col-12" style={{ marginTop: '20px' }}>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className={!isLabelChangeKanji ? 'col-sm-12 col-form-labels' : 'col-sm-12 col-form-labels1'} id='labels'>{consultKanjiName}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="form-control-search-count-label">{consultKanjiLastName}</label>
                  <Tooltip content="入力が必要です。" direction="top">
                    <input type="text" className={kanjiLastName === null || kanjiLastName === undefined || kanjiLastName === '' ? 'required-input form-control-inputdetails' : 'required-input inputEnteredText'} value={kanjiLastName} placeholder={consultKanjiLastNamePlaceHolder}
                      id="planNumber" onChange={onChangekanjiLastNameHandler} onClick={onClickFirstInput} onBlur={onBlurkanjiLastNameHandler} style={{ backgroundColor: InputChange === true ? 'rgb(255,251,214)' : '', border: ((kanjiLastName === null || kanjiLastName === undefined || kanjiLastName === '') && kanjiLastNameOuterBorderRed === true) ? '2px solid red' : '' }} /></Tooltip>
                </div>
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="form-control-search-count-label">{consultKanjiFirstName}</label>
                  <Tooltip content="入力が必要です。" direction="top">
                    <input type="text" className={kanjiFirstName === null || kanjiFirstName === undefined || kanjiFirstName === '' ? 'required-input form-control-inputdetails' : 'required-input inputEnteredText'} value={kanjiFirstName} placeholder={consultKanjiFirstNamePlaceHolder}
                      id="planNumber" onChange={onChangekanjiFirstNameHandler} onClick={onClickFirstInput1} onBlur={onBlurkanjiFirstNameHandler} style={{ backgroundColor: InputChange1 === true ? 'rgb(255,251,214)' : '', border: ((kanjiFirstName === null || kanjiFirstName === undefined || kanjiFirstName === '') && kanjiFirstNameOuterBorderRed === true) ? '2px solid red' : '' }} /></Tooltip>
                </div>
                <div className="errDisplayArea">
                  <InputScreenErrorMessage errorMessage={error.invalidFormatKanji}></InputScreenErrorMessage>
                  <InputScreenErrorMessage errorMessage={error.overCharLimitKanji}></InputScreenErrorMessage>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className={!isLabelChangeKana ? 'col-sm-12 col-form-labels' : 'col-sm-12 col-form-labels1'} id='labels'>{consultKanaName}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="form-control-search-count-label">{consultKanaLastName}</label>
                  <Tooltip content="入力が必要です。" direction="top">
                    <input type="text" className={kanaLastName === null || kanaLastName === undefined || kanaLastName === '' ? 'required-input form-control-inputdetails' : 'required-input inputEnteredText'} placeholder={consultKanaLastNamePlaceHolder}
                      id="planNumber" value={kanaLastName} onClick={onClickKana1Input} onChange={onChangeKanaLastNameHandler} onBlur={onBlurKanaLastNameHandler} style={{ backgroundColor: InputChangeKana1 === true ? 'rgb(255,251,214)' : '', border: ((kanaLastName === null || kanaLastName === undefined || kanaLastName === '') && kanaLastNameOuterBorderRed === true) ? '2px solid red' : '' }} /></Tooltip>
                </div>
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="form-control-search-count-label">{consultKanaFirstName}</label>
                  <Tooltip content="入力が必要です。" direction="top">
                    <input type="text" className={kanaFirstName === null || kanaFirstName === undefined || kanaFirstName === '' ? 'required-input form-control-inputdetails' : 'required-input inputEnteredText'} placeholder={consultKanaFirstNamePlaceHolder}
                      id="planNumber" value={kanaFirstName} onClick={onClickKanaInput} onChange={onChangeKanaFirstNameHandler} onBlur={onBlurKanaFirstNameHandler} style={{ backgroundColor: InputChangeKana === true ? 'rgb(255,251,214)' : '', border: ((kanaFirstName === null || kanaFirstName === undefined || kanaFirstName === '') && kanaFirstNameOuterBorderRed === true) ? '2px solid red' : '' }} /></Tooltip>
                </div>
                <div className="errDisplayArea">
                  <InputScreenErrorMessage errorMessage={error.invalidFormatKana}></InputScreenErrorMessage>
                  <InputScreenErrorMessage errorMessage={error.overCharLimitKana}></InputScreenErrorMessage>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{consultBirthdate}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-4 col-4">
                  <Tooltip content="選択が必要です。" direction="top">
                    <select value={year} onChange={onChangeYearHandler} className="required-input form-control-inputdetails" name="birth_year" id="contact" tabIndex="5" style={{ backgroundColor: year.length === 0 ? 'rgb(255, 229, 229)' : 'white', border: (year.length === 0 && yearOuterBorderRed === true) ? '2px solid red' : '', padding: '0px 10px' }} onBlur={onBlurYearHandler}>
                      <option value="" selected=""></option>
                      {Array.from({ length: new Date().getFullYear() - 1951 }, (_, index) => 1934 + index).map((item) => ( // startYear = 1934, endYear = currentYear - 18
                        <option key={item} value={item}>{item}</option>
                      ))}
                    </select></Tooltip>
                  <label htmlFor="inputtext" className="form-control-search-count-label-right" >{consultYear}</label>
                </div>
                <div className="col-sm-4 col-4">
                  <Tooltip content="選択が必要です。" direction="top">
                    <select type="text" className="required-input form-control-inputdetails" tabIndex="5" style={{ backgroundColor: month.length === 0 ? 'rgb(255, 229, 229)' : 'white', border: (month.length === 0 && monthOuterBorderRed === true) ? '2px solid red' : '', padding: '0px 10px' }} value={month} onChange={onChangeMonthHandler} name="birth_month" id="contact" onBlur={onBlurMonthHandler}>
                      <option value="" selected=""></option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select></Tooltip>
                  <label htmlFor="inputtext" className="form-control-search-count-label-right" >{consultMonth}</label>
                </div>
                <div className="col-sm-4 col-4">
                  <Tooltip content="選択が必要です。" direction="top">
                    <select type="text" className="required-input form-control-inputdetails"
                      id="contact" value={day} onChange={onChangeDayHandler} name="birth_day" tabIndex="7" style={{ backgroundColor: day.length === 0 ? 'rgb(255, 229, 229)' : 'white', border: (day.length === 0 && dayOuterBorderRed === true) ? '2px solid red' : '', padding: '0px 10px' }} onBlur={onBlurDayHandler}>
                      <option value="" selected=""></option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                    </select></Tooltip>
                  <label htmlFor="inputtext" className="form-control-search-count-label-right" >{consultDay}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{consultGender}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className={!gender ? 'col-sm-12 radioButtonClick' : 'col-sm-12 radioButtonOnClickWhite'}>
                  <table className='radioTable'>
                    <tbody>
                      <tr value={gender} onChange={(e) => onChangeGenderHandler(e)} onBlur={onBlurCount}>
                        <td className='radioPadding'><input type='radio' name='gender' className="required-input" id='male' value='男性' checked={gender === '男性'} style={{ outline: '0px solid #cccccc', marginRight: '5px' }} />{consultGenderMale}</td>
                        <td className='radioPadding'><input type='radio' name='gender' id='female' value='女性' checked={gender === '女性'} style={{ marginRight: '5px' }} />{consultGenderFemale}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className={!isLabelChangeZipCode ? 'col-sm-12 col-form-labels' : 'col-sm-12 col-form-labels1'} id='labels'>{consultZipcode}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6" style={{ marginBottom: '10px' }}>
                  <span>郵便番号（半角数字・ハイフンなし）</span>
                  <Tooltip content="入力が必要です。" direction="top">
                    <input type="text" className={zipcode1 === null || zipcode1 === undefined || zipcode1 === '' ? 'required-input form-control-inputdetails' : 'required-input inputEnteredText'} placeholder={consultZipcodePlaceholder1}
                      id="zipCode1" value={zipcode1} onClick={InputZip1Check} onChange={onChangeZipcode1Handler} onBlur={onBlurZipcode1Handler} style={{ backgroundColor: InputZip1 === true ? 'rgb(255,251,214)' : '', border: ((zipcode1 === null || zipcode1 === undefined || zipcode1 === '') && zipcode1OuterBorderRed === true) ? '2px solid red' : '' }} /></Tooltip>
                </div>
                <div className="col-sm-6" id="zipSearch">
                  <a href="http://www.post.japanpost.jp/zipcode/index.html" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(var(--bs-link-color-rgb' }}>郵便番号検索</a>
                </div>
                <div className="errDisplayArea">
                  <InputScreenErrorMessage errorMessage={error.insufficientInput}></InputScreenErrorMessage>
                  <InputScreenErrorMessage errorMessage={error.invalidCharZipCode}></InputScreenErrorMessage>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className={!isLabelChangePHno ? 'col-sm-12 col-form-labels' : 'col-sm-12 col-form-labels1'} id='labels'>{consultTelephoneNumber}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6" style={{ marginBottom: '10px' }}>
                  <span>携帯電話可（半角数字・ハイフンなし）</span>
                  <Tooltip content="入力が必要です。" direction="top">
                    <input type="text" className={telephone1 === null || telephone1 === undefined || telephone1 === '' ? 'required-input form-control-inputdetails' : 'required-input inputEnteredText'} value={telephone1} onClick={InputTel1Check} placeholder={consultTelephoneNumberPlaceholder1}
                      id="zipCode1" onChange={onChangeTelephone1Handler} onBlur={onBlurTelephone1Handler} style={{ backgroundColor: InputTel1 === true ? 'rgb(255,251,214)' : '', border: ((telephone1 === null || telephone1 === undefined || telephone1 === '') && telephone1uterBorderRed === true) ? '2px solid red' : '' }} /></Tooltip>
                </div>
                <div className="errDisplayArea">
                  <InputScreenErrorMessage errorMessage={error.insufficientInputs}></InputScreenErrorMessage>
                  <InputScreenErrorMessage errorMessage={error.isOverLimit}></InputScreenErrorMessage>
                  <InputScreenErrorMessage errorMessage={error.invalidFormatPhoneNumber}></InputScreenErrorMessage>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className={!isLabelChangeEmail ? 'col-sm-12 col-form-labels' : 'col-sm-12 col-form-labels1'} id='labels'>{consultEmailAddress}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6" style={{ paddingBottom: '0px' }}>
                  <Tooltip content="入力が必要です。" direction="top">
                    <input type="text" className={email === null || email === undefined || email === '' ? 'required-input form-control-inputdetails' : 'required-input inputEnteredText'} value={email} onClick={InputEmailCheck} placeholder={consultEmailAddressPlaceholder}
                      id="zipCode1" onChange={onChangeEmailHandler} onBlur={onBlurEmailHandler} style={{ backgroundColor: InputEmail === true ? 'rgb(255,251,214)' : '', border: ((email === null || email === undefined || email === '') && emailOuterBorderRed === true) ? '2px solid red' : '' }} /></Tooltip>
                </div>
                <div className="errDisplayArea">
                  <InputScreenErrorMessage errorMessage={error.invalidFormatEmail}></InputScreenErrorMessage>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{faceTofacelabelText}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className={!online ? 'col-sm-12 radioButtonClick' : 'col-sm-12 radioButtonOnClickWhite'}>
                  <table className='radioTable'>
                    <tbody >
                      <tr value={online} onChange={(e) => onChangeOnlineHandler(e)} onBlur={onBlurCount}>
                        <td className='radioPadding'><input type='radio' className='required-input' name='online' id='onLine' value='オンライン形式' checked={online === 'オンライン形式'} style={{ outline: '0px solid #cccccc', marginRight: '5px' }} />{onlineText}</td>
                        <td className='radioPadding'><input type='radio' name='online' id='faceToface' value='対面形式' checked={online === '対面形式'} style={{ marginRight: '5px' }} />{faceToface}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{consultContractStatus}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className={!contracted ? 'col-sm-12 radioButtonClick' : 'col-sm-12 radioButtonOnClickWhite'}>
                  <table className='radioTable'>
                    <tbody >
                      <tr value={contracted} onChange={(e) => onChangeContractedHandler(e)} onBlur={onBlurCount}>
                        <td className='radioPadding'><input type='radio' className='required-input' name='contracted' id='contract' value='契約あり' checked={contracted === '契約あり'} style={{ outline: '0px solid #cccccc', marginRight: '5px' }} />{consultContractStatusContracted}</td>
                        <td className='radioPadding'><input type='radio' name='contracted' id='contractNo' value='契約なし' checked={contracted === '契約なし'} style={{ marginRight: '5px' }} />{consultContractStatusNoContract}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div style={{ color: '#DB0A5B' }}>
                  <table style={{ border: '1px solid #DB0A5B', marginTop: '30px' }}>
                    <tbody><tr><td style={{ textAlign: 'center', padding: '15px 15px 0px' }}>【ご注意ください】</td></tr>
                      <tr>
                        <td style={{ top: '5px', position: 'relative', padding: '0px 15px 15px' }}>
                          契約内容のご確認、住所変更など各種お手続きや保険金・給付金のご請求についてはご契約者さま専用のお問い合わせ先をご利用ください。
                          <br/><br/>
                          <a href="https://www.metlife.co.jp/customer/contact/" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', color: '#0d6efd' }}>お問い合わせ先はこちら</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails  row" style={{ alignItems: 'normal' }}>
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{DetailsOfConsultation}<span className="required">必須</span></label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className={!detailsOfConsultation.length > 0 ? 'col-sm-12 radioButtonClick' : 'col-sm-12 radioButtonOnClickWhite'} style={{ marginTop: '0.6%' }}>
                  <table style={{ margin: '10px 0px' }}>
                    <tbody onClick={handleChangeData} onBlur={onBlurCount}>
                    <tr className="row">
                      {
                        xmlResponseData.length > 0 && xmlResponseData.map((item, i) => (
                       <td key={i} className='col-sm-12' ><input type="checkbox" checked={detailsOfConsultation.indexOf(item) > -1} onChange={(e) => onChangeDetailsOfConsultation(e, item)} style={{ outline: '0px solid #cccccc', marginLeft: '-2px' }} /><span style = {{ padding: '10px' }}>{item}</span></td>
                      ))}
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails  row" style={{ alignItems: 'normal' }}>
            <label htmlFor="inputtext" className={!isLabelChangeRemarks ? 'col-sm-12 col-form-labels' : 'col-sm-12 col-form-labels1'} id='labels'>{Remarks}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className='col-sm-12'>
                  <textarea className="col-sm-12 form-control" id="textAreaExample1" rows='3' placeholder={RemarksPlaceholder} onChange={onChangeInputEnterHandler} value={descriptionText}></textarea>
                  <p>{RemarksText}</p>
                </div>
                <div className="errDisplayArea">
                  <InputScreenErrorMessage errorMessage={error.isF2FRemarksLimit}></InputScreenErrorMessage>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="btnWrapper">
      {headerErrorMssg === true
        ? <p className="btnDiv"><input type="submit" value="未入力項目があります" name="submit" className="btnGrey" disabled="disabled" /></p>
        : <p className="btnDiv"><input type="submit" value="確認画面に進む" name="submit" className="btnYellow" onClick={SubmitButtonClick} onDoubleClick={SubmitButtonClick} /></p>
         }
      </div>
      {// EFO COUNTER
      count === 0
        ? ''
        : <div id="count-box" style={{ display: 'block', lineHeight: '1.4' }} className="fixed">
            <p style={{ marginBottom: '0px', paddingBottom: '0px' }}>入力項目は</p>
            <p style={{ marginBottom: '0px', paddingBottom: '0px' }}>残り<span className="count-txt"><span id="count-num">{count}</span>件</span></p>
            <p style={{ marginBottom: '0px', paddingBottom: '0px' }}>です</p>
      </div>}
    </div >

  )
}
export default ConsultationServiceForm
